var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.159055 7.09139C-0.0389813 7.28384 -0.0435114 7.60039 0.148937 7.79843C0.341385 7.99646 0.657935 8.00099 0.855971 7.80854L3.89859 4.85178C4.09057 4.66522 4.10155 4.36055 3.92351 4.16065L1.21672 1.12161C1.03305 0.9154 0.717 0.897124 0.510791 1.08079C0.304583 1.26445 0.286307 1.58051 0.469971 1.78672L2.85835 4.46827L0.159055 7.09139Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.5336733b46a7d8a33e269f455bf6182b.svg";
export { ForwardRef as ReactComponent };